angular.module('eStories.search', [
    'eStories.search.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.search', {
                url: 'search/:searchType/:searchKeywords',
                views: {
                    'mainView@': {
                        controller: 'SearchCtrl as searchCtrl',
                        templateUrl: 'search/searchResults.tmpl.html'
                    }
                }
            });
    }])

    .controller('SearchCtrl', [
        '$stateParams',
        'SearchModel',
        'PagingModel',
        '$location',
        'LL',
        'GA',
        function ($stateParams,
                  SearchModel,
                  PagingModel,
                  $location,
                  LL,
                  GA) {

            $location.url($location.path());
            var searchCtrl = this;

            GA.trackPageView($location.path());

            searchCtrl.textToFind = $stateParams.searchKeywords;
            searchCtrl.searchType = $stateParams.searchType;

            var textualNumberOfResults = 8;
            var audiobooksNumberOfResults = 12;
            var desc = true;
            searchCtrl.gotResults = true;
            searchCtrl.narratorPagination = PagingModel.preparePagination(1, textualNumberOfResults, desc, false);
            searchCtrl.authorPagination = PagingModel.preparePagination(1, textualNumberOfResults, desc, false);
            searchCtrl.publisherPagination = PagingModel.preparePagination(1, textualNumberOfResults, desc, false);
            searchCtrl.audiobookPagination = PagingModel.preparePagination(1, audiobooksNumberOfResults, desc, false);
            searchCtrl.results = {};


            searchCtrl.addItemsToLocalResults = function (arrayAttr, serverResultArray, pageSize) {
                if (serverResultArray && serverResultArray.length) {
                    // No more results
                    searchCtrl.results[arrayAttr + "Show"] = serverResultArray.length == pageSize;

                    if (searchCtrl.results[arrayAttr]) {
                        searchCtrl.results[arrayAttr] = searchCtrl.results[arrayAttr].concat(serverResultArray);
                    } else {
                        searchCtrl.results[arrayAttr] = serverResultArray;
                    }
                }
            };

            searchCtrl.loadMoreAuthors = function () {
                searchCtrl.authorPagination.pageNumber++;
                searchCtrl.loadResults(searchCtrl.textToFind, null, searchCtrl.authorPagination, null, null, true);
            };

            searchCtrl.loadMoreNarrators = function () {
                searchCtrl.narratorPagination.pageNumber++;
                searchCtrl.loadResults(searchCtrl.textToFind, searchCtrl.narratorPagination, null, null, null, true);
            };

            searchCtrl.loadMorePublishers = function () {
                searchCtrl.publisherPagination.pageNumber++;
                searchCtrl.loadResults(searchCtrl.textToFind, null, null, searchCtrl.publisherPagination, null, true);
            };

            searchCtrl.loadMoreAudiobooks = function () {
                searchCtrl.audiobookPagination.pageNumber++;
                searchCtrl.loadResults(searchCtrl.textToFind, null, null, null, searchCtrl.audiobookPagination, true);
            };

            searchCtrl.loadResults = async function (textToFind,
                                                     narratorPagination,
                                                     authorPagination,
                                                     publisherPagination,
                                                     audiobookPagination,
                                                     isLoadMore) {

                const fetchFunction = searchCtrl.searchType === "store"
                    ? SearchModel.searchStore
                    : SearchModel.searchLibrary;

                searchCtrl.loadingMoreNarrators = !!narratorPagination;
                searchCtrl.loadingMoreAuthors = !!authorPagination;
                searchCtrl.loadingMorePublishers = !!publisherPagination;
                searchCtrl.loadingMoreAudiobooks = !!audiobookPagination;

                const response = await fetchFunction(textToFind, narratorPagination, publisherPagination,
                    authorPagination, audiobookPagination);

                if (!response || response.responseStatus !== "SUCCESS") {
                    return;
                }

                if (searchCtrl.searchType !== 'store') {
                    response.audiobookList = response.libraryAudiobookList.map(i => i.audiobook);
                }

                if (!isLoadMore) {
                    LL.tagSearchCatalogEvent(
                        textToFind,
                        response.authorList.length,
                        response.narratorList.length,
                        response.publisherList.length,
                        response.audiobookList.length,
                        false,
                        SearchModel.createArrayOfBookIds(response)
                    );
                }

                searchCtrl.addItemsToLocalResults("narratorList", response.narratorList,
                    textualNumberOfResults);
                searchCtrl.addItemsToLocalResults("publisherList", response.publisherList,
                    textualNumberOfResults);
                searchCtrl.addItemsToLocalResults("authorList", response.authorList,
                    textualNumberOfResults);
                searchCtrl.addItemsToLocalResults("audiobookList", response.audiobookList,
                    audiobooksNumberOfResults);

                searchCtrl.gotResults = response.narratorList.length ||
                    response.publisherList.length ||
                    response.authorList.length ||
                    (response.audiobookList && response.audiobookList.length);

                searchCtrl.loadingMoreNarrators = false;
                searchCtrl.loadingMoreAuthors = false;
                searchCtrl.loadingMorePublishers = false;
                searchCtrl.loadingMoreAudiobooks = false;
            };

            // Load initial results
            searchCtrl.loadResults(searchCtrl.textToFind,
                searchCtrl.narratorPagination,
                searchCtrl.authorPagination,
                searchCtrl.publisherPagination,
                searchCtrl.audiobookPagination).then();

            /*Localytics Events*/
            searchCtrl.tagSearchSelectAuthorLlEvent = function (author) {
                LL.tagSearchSelectAuthorLlEvent(author.name);
            };

            searchCtrl.tagSearchSelectNarratorLlEvent = function (narrator) {
                LL.tagSearchSelectNarratorLlEvent(narrator.name);
            };

            searchCtrl.tagSearchSelectPublisherLlEvent = function (publisher) {
                LL.tagSearchSelectPublisherLlEvent(publisher.name);
            };

            searchCtrl.tagSearchSelectTitleLlEvent = function (bookObj) {
                LL.tagSearchSelectTitleLlEvent(bookObj.title);
            };
        }]);